import { SESSION_STORAGE_KEY_PREFIX } from '../constants/sessionStorageKeyPrefix';

export const clearAllSessionStorageKeys = () => {
  for (const [key] of Object.entries(sessionStorage)) {
    if (key.startsWith(SESSION_STORAGE_KEY_PREFIX)) {
      sessionStorage.removeItem(key);
    }
  }
};
